import { render, staticRenderFns } from "./CartaoEndereco.vue?vue&type=template&id=0d5f4fda&scoped=true"
import script from "./CartaoEndereco.vue?vue&type=script&lang=js"
export * from "./CartaoEndereco.vue?vue&type=script&lang=js"
import style0 from "./CartaoEndereco.vue?vue&type=style&index=0&id=0d5f4fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f4fda",
  null
  
)

export default component.exports